import { render, staticRenderFns } from "./ManageLabelSets.vue?vue&type=template&id=6baf94a4&scoped=true"
import script from "./ManageLabelSets.vue?vue&type=script&lang=js"
export * from "./ManageLabelSets.vue?vue&type=script&lang=js"
import style0 from "./ManageLabelSets.vue?vue&type=style&index=0&id=6baf94a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf94a4",
  null
  
)

export default component.exports